import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { SafeHtmlPipe } from 'src/app/pipes/safe-html.pipe';

/**
 * Component for displaying a message dialog.
 * This component provides a dialog with a title, message, and an Ok button for acknowledging the message.
 */
@Component({
  selector: 'message-dialog',
  standalone: true,
  imports: [MatDialogModule, TranslateModule, SafeHtmlPipe],
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss'],
})
export class MessageDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<MessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
    }
  ) {}

  onOk(): void {
    this.dialogRef.close();
  }
}
